var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fixedTitle)?_c('div',[_vm._v(" "+_vm._s(_vm.fixedTitle)+" - via "),_c('a',{attrs:{"href":_vm.article.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.article.source.name))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }